
import { Grid } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useLanguageContext } from '../../../../contexts/LanguageContext';
import Drawer, { IDefaultDrawerProps } from '../../../../components/Drawer';
import { ActionButton } from '../../../../components/Button';
import TextField from '../../../../components/TextField';
import SelectField from '../../../../components/SelectField';
import FormHelper from '../../../../helpers/FormHelper';
import { RegistrationStatusData, RegistrationStatusEnum } from '../../../../data/Enums';
import DateField from '../../../../components/DateField';
import Operators from '../../../../data/Operators';
import useState from '../../../../hooks/useState';


interface IEnterpriseFilterProps extends IDefaultDrawerProps {
    handleApplyFilters: (formData: FormData) => void;
}

interface IStateValues {
    name: string;
    expirationOperator: string;
    expiration: Date | undefined;
    registrationStatus: number[];
}


const Filters: React.FC<IEnterpriseFilterProps> = ({
    open,
    handleClose,
    handleApplyFilters
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        name: '',
        expirationOperator: Operators[0],
        expiration: undefined,
        registrationStatus: [RegistrationStatusEnum.Active, RegistrationStatusEnum.Inactive]
    });


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleApplyFilters(formData);
        handleClose();
        // eslint-disable-next-line
    }, []);


    const footer = useMemo(() => {
        return <ActionButton
            action='apply'
            fullWidth={true}
            className='text-alwaysshow'
            type='submit'
        />;
        // eslint-disable-next-line
    }, [translate]);
    

    return (
        <Drawer
            anchor='right'
            open={open}
            handleClose={handleClose}
            title={translate('filter')}
            footer={footer}
            onSubmit={handleSubmit}
        >
            <Grid container>
                <Grid item xs={12}>
                    <TextField 
                        label={translate('name')} 
                        name='name' 
                        value={state.values.name} 
                        onChange={e => state.update(e.target.name, e.target.value)}
                        required={false}
                    />
                </Grid>

                <Grid item xs={4}>
                    <SelectField
                        label={translate('operator')}
                        name='expirationOperator'
                        value={state.values.expirationOperator}
                        required={true}
                        onChange={e => state.update(e.target.name, e.target.value)}
                        data={Operators}
                    />
                </Grid>

                <Grid item xs={8}>
                    <DateField
                        label={translate('expiration')}
                        format='DD/MM/YYYY'
                        name='expiration'
                        value={state.values.expiration}
                        onChange={value => state.update('expiration', value)}
                        required={false}
                    />
                </Grid>
                
                <Grid item xs={12}>
                    <SelectField
                        label={translate('situation')}
                        name='registrationStatus'
                        value={state.values.registrationStatus}
                        multiple={true}
                        required={true}
                        onChange={e => state.update(e.target.name, e.target.value)}
                        data={Object.values(RegistrationStatusData).filter(s => s.visible).map(s => {
                            return {
                                value: s.id,
                                text: translate(s.name)
                            };
                        })}
                    />
                </Grid>
            </Grid>
        </Drawer>
    );
}

export default Filters;